import request from '@/utils/request'

const ApiUrl = '/admin_api/v1/account/role'

export function getList(params) {
  return request.get(`${ApiUrl}/list/`, { params })
}

export function getDetail(roleId) {
  return request.get(`${ApiUrl}/${roleId}/`)
}

export function add(data) {
  return request.post(`${ApiUrl}/list/`, data)
}

export function edit(roleId, data) {
  return request.put(`${ApiUrl}/${roleId}/`, data)
}

export function del(roleId) {
  return request.delete(`${ApiUrl}/${roleId}/`)
}

export function getPermissionOptions() {
  return request.get(`${ApiUrl}/permission-options/`)
}
